const styles = theme => ({
  root: {

  },
  title: {
    '& h2': {
      textTransform: 'uppercase',
      color: '#1C408C!important',
      fontSize: '1.2rem!important',
      fontWeight: '600!important'
    }
  },
   subtitle: {
    '& h2': {
      textTransform: 'uppercase',
      fontSize: '1rem!important',
      fontWeight: '500!important'
    }
  },
  confirmText: {

  },
  confirmSecondaryText: {
    fontStyle: 'italic',
    marginTop: theme.spacing.unit * 2
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding: 0,
    minWidth: 40,
    marginTop: '-5px',
    float: 'right',
  },
  HighlightUserDetails: {
    '& b': {
      color: '#1C408C!important',
      textTransform: 'none',
      fontSize: '0.9rem!important',
      marginLeft: '1px',
      marginRight: '2px'
    }
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/components/common/dialog/confirm/styles.js